var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.821 11.045c.703-1.309-.891-.912-.891-.912s-10.627 10.201-12.104 8.951 10.405-11.027 8.999-12.854c-1.301-1.703-11.74 10.455-12.994 8.97-1.242-1.482 8.939-12.123 8.939-12.123s.387-1.602-.912-.9c-16.007 8.608-18.046 16.633-18.046 16.633s-.551 1.563.645 2.771c.117.105-29.204 29.26-33.129 33.196-1.91 1.908 5.098 8.801 6.996 6.893 3.926-3.936 33.024-33.303 33.129-33.194 1.207 1.205 2.766.652 2.766.652s8.012-2.045 16.602-18.083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.028 40.507c7.803 7.82 20.958 20.999 20.958 20.999s5.742-1.879 6.551-6.729l-20.875-20.916c-1.946 1.946-4.205 4.208-6.634 6.646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.76 33.729c3.099-3.097 5.99-5.993 8.387-8.4l-22.688-22.731s-.41-.43-1.313.477c-1.793 1.787-5.262 13.173 9.445 27.902 2.331 2.336 4.359 2.66 6.169 2.752"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/Food.9d8c06e56f54830c7caebea6f623cf63.svg";
export { ForwardRef as ReactComponent };